import { Drawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { optionsBranch } from "../../data/branch-data";
import { useForm, Controller } from "react-hook-form";
import MergeCompany from "../MergeCompany";

const DrawerReviewCompany = ({
  isOpen,
  setIsOpen,
  companySelected,
  setCompanySelected,
}) => {
  const { register, control, watch, reset } = useForm();
  const getName = localStorage.getItem("name");

  const [onMerge, setOnMerge] = useState(false);
  const [companyTarget, setCompanyTarget] = useState(null);

  const onCloseDrawer = () => {
    setIsOpen(false);
    setOnMerge(false);
    setCompanySelected(null);
  };

  useEffect(() => {
    if (companySelected && optionsBranch.length) {
      const branchArr = companySelected.branch.replaceAll(" ", ",").split(",");

      const branchOpts = branchArr.map((item) => {
        return optionsBranch.find((el) => el?.label == item);
      });

      const defaultValues = {
        // cp_id: companySelected?.id,
        cp_name: companySelected?.name,
        cp_address: companySelected?.address,
        cp_road: companySelected?.road,
        cp_subdistrict: companySelected?.subdistrict,
        cp_district: companySelected?.district,
        cp_province: companySelected?.province,
        cp_zip: companySelected?.zip,
        cp_tel: companySelected?.tel,
        cp_email: companySelected?.email,
        cp_branch_raw: branchOpts,
      };

      reset(defaultValues);
    }
  }, [companySelected, optionsBranch]);

  // useEffect(() => {}, []);

  const displayBody = (
    <div className="p-2" style={{ width: "80vw", maxWidth: "800px" }}>
      <h2 className="mb-4">ตรวจสอบสถานประกอบการ</h2>

      <div className="row g-3">
        <div className="col-md-3">รหัสสถานประกอบการ</div>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            readOnly
            name="cp_id"
            value={companySelected?.id}
          />
        </div>
        <div className="col-md-3">ชื่อสถานประกอบการ</div>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control "
            {...register("cp_name")}
          />
        </div>
        <div className="col-md-3">ที่อยู่</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_address")}
          />
        </div>
        <div className="col-md-3">ถนน</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_road")}
          />
        </div>
        <div className="col-md-3">ตำบล</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_subdistrict")}
          />
        </div>
        <div className="col-md-3">อำเภอ</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_district")}
          />
        </div>
        <div className="col-md-3">จังหวัด</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_province")}
          />
        </div>
        <div className="col-md-3">รหัสไปรษณีย์</div>
        <div className="col-md-3">
          <input
            type="number"
            className="form-control "
            {...register("cp_zip")}
          />
        </div>
        <div className="col-md-3">เบอร์โทร</div>
        <div className="col-md-3">
          <input
            type="text"
            className="form-control "
            {...register("cp_tel")}
          />
        </div>
        <div className="col-md-3">อีเมล</div>
        <div className="col-md-3">
          <input
            type="email"
            className="form-control "
            {...register("cp_email")}
          />
        </div>
        <div className="col-md-3">สาขาที่เกี่ยวข้อง</div>
        <div className="col-md-9">
          <Controller
            name="cp_branch_raw"
            control={control}
            render={({ field }) => {
              return <Select options={optionsBranch} isMulti {...field} />;
            }}
          />
          <input
            className="form-control d-none"
            type="text"
            {...register("cp_branch")}
            value={
              watch("cp_branch_raw") && watch("cp_branch_raw").length
                ? watch("cp_branch_raw")
                    ?.map((el) => el?.label)
                    ?.join(",")
                : null
            }
          />
          <input
            className="form-control d-none"
            type="text"
            {...register("user")}
            value={getName}
          />
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <Drawer anchor="right" open={isOpen} onClose={onCloseDrawer}>
        <form method="post" action="./update-company.php">
          {displayBody}

          <div className="px-2">
            {!!companySelected?.st_object?.length &&
              companySelected?.st_object?.map((st, stIndex) => {
                return (
                  <div className="d-flex justify-content-start" key={stIndex}>
                    <div>{st.st__st_name} </div>
                    <div className="ms-5">
                      {
                        optionsBranch?.find((el) => el.value == st?.st__b_id)
                          ?.label
                      }
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="mt-4 d-flex justify-content-center">
            <div
              className="btn btn-outline-warning me-2"
              onClick={() => setOnMerge(true)}
            >
              รวมบริษัท
            </div>
            <div className="btn btn-secondary me-2" onClick={onCloseDrawer}>
              Close
            </div>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </form>

        {onMerge && (
          <MergeCompany
            companySource={companySelected}
            companyTarget={companyTarget}
            setCompanyTarget={setCompanyTarget}
          />
        )}
      </Drawer>
    </div>
  );
};

export default DrawerReviewCompany;
